import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally { setBusy(false); }
  };

  return (
    <div className="auth-wrap">
      <motion.form className="auth-card" onSubmit={submit}
        initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <img src="/logo-full.png" alt="VeriAuth" data-testid="login-logo"
          style={{ width: 150, display: "block", margin: "0 auto 10px" }} />
        <div className="eyebrow" style={{ textAlign: "center", marginBottom: 4 }}>Team access</div>
        <h1 style={{ fontSize: 22, color: "var(--head)", textAlign: "center", margin: "0 0 18px" }}>VeriScan Leads Dashboard</h1>
        <label htmlFor="email">Email</label>
        <input id="email" data-testid="login-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <label htmlFor="password">Password</label>
        <input id="password" data-testid="login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <div className="err" data-testid="login-error">{err}</div>
        <button className="btn" data-testid="login-submit" style={{ width: "100%", justifyContent: "center", marginTop: 8 }} disabled={busy}>
          {busy ? <><span className="spin" /> Signing in…</> : "Sign in →"}
        </button>
      </motion.form>
    </div>
  );
}
